angular
  .module('EdxManageCommonModule')
  .controller('EdxPendingChangesModalController', function ($scope, $modalInstance) {
    $scope.ok = function () {
      $modalInstance.close();
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };
  })
  .service('edxPendingChangesModalService', [
    '$modal',
    '$q',
    function ($modal, $q) {
      var _isPending = false;

      this.open = function () {
        var modalInstance = $modal.open({
          animation: true,
          templateUrl: 'resources/components/manage/common/pending-changes-modal/edx-pending-changes-modal.html',
          windowClass: 'dirty-modal',
          controller: 'EdxPendingChangesModalController',
          backdrop: 'static',
          keyboard: false
        });

        return modalInstance.result.then(
          function (x) {
            _isPending = false;
          },
          function (reason) {
            return $q.reject(reason);
          }
        );
      };

      this.setIsPending = function (isPending) {
        _isPending = isPending;
      };

      this.isPending = function () {
        return _isPending;
      };

      window.onbeforeunload = function (event) {
        if (_isPending) {
          return 'You have unsaved changes.';
        } else {
          // IE11 doesn't like nulls, so just return
          return;
        }
      };
    }
  ]);
